import * as Yup from 'yup';
import { RolesMode } from '../../../entities/Roles';
import { tripStatuses, TripStatusIds } from '../../../entities/Trip';

// export const validationSchema = Yup.object().shape({
//   orders: Yup.array()
//     .of(
//       Yup.object().shape({
//         number: Yup.string().nullable().required('Поле "Наряд" обов\'язкове'),
//         netWeight: Yup.string().nullable().required('Поле "Вага НЕТТО" обов\'язкове'),
//         packageWeight: Yup.string().nullable().required('Поле "Вага упаковки" обов\'язкове'),
//         bruttoWeight: Yup.string(),
//       }),
//     )
//     .required('Заповніть всі поля'),
//   addedPerforationWeight: Yup.string().nullable().required("Поле обов'язкове"),
//   departureVehicleWeight: Yup.number()
//     .integer('Значення має бути цілим числом')
//     .positive('Поле "Вага автомобіля на виїзді" повинно бути більше нуля')
//     .required('Поле "Вага автомобіля на виїзді" обов\'язкове'),
//   allowWithTolerance: Yup.boolean().oneOf([true], 'Поле "Дозволити виїзд" обов\'язкове'),
//   isNotLoaded: Yup.boolean(),
// });

export const getValidationSchema = (mode: RolesMode, status: TripStatusIds | number, operatingProcedure: string) => {
  const isSecurity = mode === 'security';
  const isDirector = mode === 'director';
  const isWaitingAdminStatus = status === tripStatuses.waitingAdmin;
  const isOrdering = mode === 'ordering';
  return Yup.object().shape({
    orders: Yup.array()
      .of(
        Yup.object().shape({
          number: Yup.string().nullable().required('Поле "Наряд" обов\'язкове'),
          netWeight: Yup.number().when([], {
            is: () => !isOrdering || operatingProcedure === 'Порядок 3',
            then: (schema) =>
              schema
                .nullable()
                .required('Поле "Вага НЕТТО" обов\'язкове')
                .test('not-zero', 'Поле "Вага НЕТТО" не може дорівнювати 0', (value) => String(value).trim() !== '0'),
          }),
          packageWeight: Yup.string().nullable().required('Поле "Вага упаковки" обов\'язкове'),
          bruttoWeight: Yup.string().nullable(),
        }),
      )
      .required('Заповніть всі поля'),
    addedPerforationWeight: Yup.string().test('len', 'Поле "Вага перфорації" обов\'язкове', (value = '') => {
      const changedValue = value.replace(/\D+/g, '');
      return changedValue.length > 0;
    }),
    departureVehicleWeight: Yup.number().when([], {
      is: () => isSecurity,
      then: (schema) =>
        schema
          .integer('Значення має бути цілим числом')
          .positive('Поле "Вага автомобіля на виїзді" повинно бути більше нуля')
          .required('Поле "Вага автомобіля на виїзді" обов\'язкове'),
      otherwise: (schema) => schema.notRequired(),
    }),
    allowWithTolerance: (() => {
      let validation = Yup.boolean();
      if ((isSecurity && isWaitingAdminStatus) || isDirector) {
        validation = validation
          .oneOf([true], 'Поле "Дозволити виїзд" обов\'язкове')
          .required('Поле "Дозволити виїзд" обов\'язкове');
      }
      return validation;
    })(),
  });
};
